module.exports = __webpack_public_path__ + "static/sf_10.8045f240.png";